import { useId } from 'react'
import { useOverlay } from '@comforthub/design-system'
import AssistantPanel from './AssistantPanel'

interface Props {
  open: boolean
  onClose: () => void
  /** Bumped when the user opens the AI, so focus goes to the message box. */
  focusToken?: number
}

/** Below 1024 px the AI opens over the page from the header sparkle. */
export default function AssistantDrawer({ open, onClose, focusToken }: Props) {
  const titleId = useId()
  // Escape closes the drawer, Tab stays inside it, and focus goes back to the
  // button that opened it.
  const panelRef = useOverlay<HTMLElement>({ open, onClose })

  if (!open) return null

  return (
    <div className="fixed inset-0 z-50 flex justify-start animate-in fade-in duration-200">
      <aside
        ref={panelRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        tabIndex={-1}
        className="w-full max-w-md h-full bg-surface border-r border-border shadow-xl flex flex-col ring-1 ring-inset ring-accent/10 outline-none animate-in slide-in-from-left-2 duration-200"
      >
        <h2 id={titleId} className="sr-only">
          Assistant
        </h2>
        <AssistantPanel
          variant="drawer"
          active={open}
          onClose={onClose}
          focusToken={focusToken}
          closeOnNavigate
        />
      </aside>
      <button
        type="button"
        className="flex-1 bg-black/30 backdrop-blur-[2px]"
        aria-label="Close"
        onClick={onClose}
      />
    </div>
  )
}
